"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSurveyDto = void 0;
const misc_1 = require("../../../misc");
const survey_1 = require("../survey");
class CreateSurveyDto extends (0, misc_1.generateCreateDto)(survey_1.Survey, ['appServiceQuality', 'doctorQuality', 'videoCallQuality', 'extraMessage']) {
}
exports.CreateSurveyDto = CreateSurveyDto;
